export default "__VITE_ASSET__96be8605__"